/**
 * Where a zamówienie is on its way from ordered to shipped. Derived by the backend from
 * the links on its positions; only Confirmed is a person's decision (confirmedAt), and it
 * only shows while no link has taken over yet.
 */
export enum ClientOrderStatus {
  new,
  confirmed,
  inProduction,
  partiallyShipped,
  shipped
}

import { OrderPhoto } from '../../orders-new/models/order.dto';

export interface ClientOrderListItemDto {
  id: number;
  orderNumber: string;
  clientName: string;
  name: string | null;
  createdAt: string;
  deadline: string | null;
  confirmedAt: string | null;
  status: ClientOrderStatus;
  /**
   * Coverage counted position-wise: how many of the positions are covered in full by
   * allocations, and how many were shipped in full (Shipped wysyłki only).
   */
  positionCount: number;
  positionsAllocated: number;
  positionsShipped: number;
  /**
   * The zamówienie's faces (0082): every photographed position, in position order,
   * distinct by attachment — the list row shows the first, a click flips to the next (0085).
   */
  photos: OrderPhoto[];
}
